
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as failed4wX_raNKv0IqiHwWlCn4j66f3rLuSfhx8QAQNH01XhMMeta } from "/vercel/path0/pages/failed.vue?macro=true";
import { default as welcomeKzeXs0p_eM_45zf48NWG2WREJVkFVHHBpdRn4wjKOgR7IMeta } from "/vercel/path0/pages/welcome.vue?macro=true";
import { default as loginyS_635ZNODza5tjO9y_Kjsm5BWP5YDEqDSMaxBi9pVEMeta } from "/vercel/path0/pages/auth/login.vue?macro=true";
import { default as indexOJJqd7BbHjDyf0bLKKa5FAZIXVX8zPgYa4wQdOwWPeMMeta } from "/vercel/path0/pages/users/index.vue?macro=true";
import { default as sign_45upe8mTS5UwXGN7sHPR_45rdSJ7cbuefT_d0hS51kyNiO2WsMeta } from "/vercel/path0/pages/auth/sign-up.vue?macro=true";
import { default as indexM4C48bBVkSdv1Qn_ZW1wV2zDvahwBY55H_UTHzClza4Meta } from "/vercel/path0/pages/administration/index.vue?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "failed",
    path: "/failed",
    component: () => import("/vercel/path0/pages/failed.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: welcomeKzeXs0p_eM_45zf48NWG2WREJVkFVHHBpdRn4wjKOgR7IMeta || {},
    component: () => import("/vercel/path0/pages/welcome.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginyS_635ZNODza5tjO9y_Kjsm5BWP5YDEqDSMaxBi9pVEMeta || {},
    component: () => import("/vercel/path0/pages/auth/login.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: indexOJJqd7BbHjDyf0bLKKa5FAZIXVX8zPgYa4wQdOwWPeMMeta || {},
    component: () => import("/vercel/path0/pages/users/index.vue")
  },
  {
    name: "auth-sign-up",
    path: "/auth/sign-up",
    meta: sign_45upe8mTS5UwXGN7sHPR_45rdSJ7cbuefT_d0hS51kyNiO2WsMeta || {},
    component: () => import("/vercel/path0/pages/auth/sign-up.vue")
  },
  {
    name: "administration",
    path: "/administration",
    meta: indexM4C48bBVkSdv1Qn_ZW1wV2zDvahwBY55H_UTHzClza4Meta || {},
    component: () => import("/vercel/path0/pages/administration/index.vue")
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  }
]